import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { decodeJwt } from 'jose'
import { Grid } from '@mui/material'

import Button from '../components/Button'
import InputField from '../components/InputField'
import GridHeader from '../components/GridHeader'
import { config } from '../settings/configs'
import { titlesImpostazioni, phrasesImpostazioni } from '../settings/settings'
import { useFeedback } from '../hooks/feedback-hook'
import { useResetPasswordMutation } from '../hooks/api-slice'

const ResetPassword = () => {
  const [codiceUtente, setCodiceUtente] = useState()
  const [newPassword, setNewPassword] = useState()
  const [loading, setLoading] = useState()

  const { setFeedback } = useFeedback()
  const [resetPassword] = useResetPasswordMutation()

  const [searchParams] = useSearchParams()
  const resetToken = searchParams.get('resetToken')

  useEffect(() => {
    if (!resetToken) return
    try {
      const { codiceUtente } = decodeJwt(resetToken)
      setCodiceUtente(codiceUtente)
    } catch {
      setCodiceUtente()
    }
  }, [resetToken])

  const triggerRequest = async () => {
    setLoading(true)
    const result = await resetPassword({ resetToken, newPassword })
    setLoading()

    if (result?.error) {
      setFeedback(
        result?.error?.data?.message,
        true,
        titlesImpostazioni.titleResetPassword,
      )
      return
    }

    setFeedback(
      phrasesImpostazioni.phraseResetPassword,
      false,
      titlesImpostazioni.titleResetPassword,
      '/',
    )
  }

  document.title = `${config?.name} - Reset password`

  return (
    <Grid container spacing={3} paddingX={2} sx={{ width: '100%' }}>
      <GridHeader h2 text='Reset password' />
      <Grid container spacing={2} sx={{ width: '100%' }}>
        <Grid size={{ xs: 2, md: 4 }} />
        <Grid size={{ xs: 8, md: 4 }}>
          <InputField
            id='codice'
            value={codiceUtente}
            label='Codice utente'
            readOnly
          />
        </Grid>
      </Grid>
      <Grid container sx={{ width: '100%' }}>
        <Grid size={{ xs: 2, md: 4 }} />
        <Grid size={{ xs: 8, md: 4 }}>
          <InputField
            id='new-password'
            value={newPassword}
            onChange={setNewPassword}
            label='Nuova password'
            type='password'
            autoFocus
          />
        </Grid>
      </Grid>
      <Grid size={12}>
        <center>
          <Button
            loading={loading}
            disabled={!codiceUtente || !newPassword}
            onClick={triggerRequest}
          >
            Vai
          </Button>
        </center>
      </Grid>
    </Grid>
  )
}

export default ResetPassword
